import React from 'react';
import Navbar from '../components/Layouts/Navbar';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';
import WooCommerceSchnittstelleHeader from '../components/WooCommerceSchnittstelle/WooCommerceSchnittstelleHeader';
import WooCommerceSchnittstelleFeatures from '../components/WooCommerceSchnittstelle/WooCommerceSchnittstelleFeatures';
import WooCommerceSchnittstelleHowItWorks from '../components/WooCommerceSchnittstelle/WooCommerceSchnittstelleHowItWorks';
import WooCommerceSchnittstelleIntegration from '../components/WooCommerceSchnittstelle/WooCommerceSchnittstelleIntegration';
import WooCommerceSchnittstellePricing from '../components/WooCommerceSchnittstelle/WooCommerceSchnittstellePricing';
import WooCommerceSchnittstelleFAQ from '../components/WooCommerceSchnittstelle/WooCommerceSchnittstelleFAQ';
import WooCommerceSchnittstelleCTA from '../components/WooCommerceSchnittstelle/WooCommerceSchnittstelleCTA';
import WooCommerceSchnittstelleGallery from '../components/WooCommerceSchnittstelle/WooCommerceSchnittstelleGallery';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';

const WooCommerceSchnittstelle = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('woocommerceSchnittstelle_page_title')}
                description={t('woocommerceSchnittstelle_page_description')}
                canonical={`${baseUrl}/woocommerce-schnittstelle/`}
                openGraph={{
                    url: `${baseUrl}/woocommerce-schnittstelle/`,
                    title: t('woocommerceSchnittstelle_page_ogTitle'),
                    description: t('woocommerceSchnittstelle_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1080,
                            height: 1080,
                            alt: 'WooCommerce Schnittstelle',
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: 'Simplify Data',
                    locale: 'de_DE',
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('woocommerceSchnittstelle_page_keywords'),
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                ]}
            />

            <Navbar />
            <WooCommerceSchnittstelleHeader />
            <WooCommerceSchnittstelleFeatures />
            <WooCommerceSchnittstelleHowItWorks />
            <WooCommerceSchnittstelleIntegration />
            <WooCommerceSchnittstelleGallery />
            <WooCommerceSchnittstellePricing />
            <WooCommerceSchnittstelleFAQ />
            <WooCommerceSchnittstelleCTA />
            <SubscribeStyleOne />
            <Footer />
        </>
    );
};

export default WooCommerceSchnittstelle;

